import type { BadgeProps } from '@mbbe/ui';
import type {
  SupportIssuePriority,
  SupportIssueStatus,
  SupportIssueType,
} from '@mbbe/types';

type BadgeVariant = NonNullable<BadgeProps['variant']>;

export const STATUS_LABELS: Record<SupportIssueStatus, string> = {
  open: 'Açık',
  in_progress: 'İşlemde',
  waiting_customer: 'Yanıtınız Bekleniyor',
  resolved: 'Çözüldü',
  reopen_requested: 'Yeniden Açma İsteği',
  closed: 'Kapalı',
  rejected: 'Reddedildi',
};

export const STATUS_COLORS: Record<SupportIssueStatus, BadgeVariant> = {
  open: 'warning',
  in_progress: 'info',
  waiting_customer: 'brand',
  resolved: 'success',
  reopen_requested: 'warning',
  closed: 'default',
  rejected: 'error',
};

export const PRIORITY_LABELS: Record<SupportIssuePriority, string> = {
  low: 'Düşük',
  normal: 'Normal',
  high: 'Yüksek',
  urgent: 'Acil',
};

export const PRIORITY_COLORS: Record<SupportIssuePriority, BadgeVariant> = {
  low: 'default',
  normal: 'default',
  high: 'warning',
  urgent: 'error',
};

export const TYPE_LABELS: Record<SupportIssueType, string> = {
  bug: 'Hata',
  feature: 'Özellik Talebi',
  question: 'Soru',
};

export const STATUS_FILTERS: { label: string; value: SupportIssueStatus | 'all' }[] = [
  { label: 'Tümü', value: 'all' },
  { label: STATUS_LABELS.open, value: 'open' },
  { label: STATUS_LABELS.in_progress, value: 'in_progress' },
  { label: STATUS_LABELS.waiting_customer, value: 'waiting_customer' },
  { label: STATUS_LABELS.resolved, value: 'resolved' },
  { label: STATUS_LABELS.reopen_requested, value: 'reopen_requested' },
  { label: STATUS_LABELS.closed, value: 'closed' },
  { label: STATUS_LABELS.rejected, value: 'rejected' },
];

export const TYPE_OPTIONS: { label: string; value: SupportIssueType }[] = [
  { label: TYPE_LABELS.bug, value: 'bug' },
  { label: TYPE_LABELS.feature, value: 'feature' },
  { label: TYPE_LABELS.question, value: 'question' },
];

export const PRIORITY_OPTIONS: { label: string; value: SupportIssuePriority }[] = [
  { label: PRIORITY_LABELS.low, value: 'low' },
  { label: PRIORITY_LABELS.normal, value: 'normal' },
  { label: PRIORITY_LABELS.high, value: 'high' },
  { label: PRIORITY_LABELS.urgent, value: 'urgent' },
];

export function formatDateTimeTr(iso: string): string {
  return new Date(iso).toLocaleString('tr-TR', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
}

export function formatDateTime(iso: string, language: 'tr' | 'en'): string {
  return new Date(iso).toLocaleString(language === 'tr' ? 'tr-TR' : 'en-US', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
}
